import type { Geolocation } from "@/lib/geolocation"

export const distanceKeyToOption = (
  key: Geolocation.DistanceKey
): Geolocation.DistanceOption => {
  return Number(key.replace(`km`, ``)) as Geolocation.DistanceOption
}

export const distanceOptionToKey = (
  option: Geolocation.DistanceOption
): Geolocation.DistanceKey => {
  return `${option}km`
}
